import { render } from "./ResetPasswordConfirmModal.vue?vue&type=template&id=0fc85184"
import script from "./ResetPasswordConfirmModal.vue?vue&type=script&lang=js"
export * from "./ResetPasswordConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__